module.exports = __webpack_public_path__ + "img/sdg8_id.136b9866.svg";